/**
 * Get counts of different error types
 * @param {fabric.Textbox} textbox - The textbox object
 * @returns {object} Error counts
 */
export const getErrorCounts = (textbox) => {
  let matches = [];

  // Use SpellCheckTextbox method if available
  if (typeof textbox.getSpellCheckErrors === 'function') {
    matches = textbox.getSpellCheckErrors();
  } else {
    matches = textbox.spellCheckResults?.matches || [];
  }

  const fixable = matches.filter(
    (match) => match.replacements && match.replacements.length > 0
  );
  const informational = matches.filter(
    (match) => !match.replacements || match.replacements.length === 0
  );

  return {
    fixable: fixable.length,
    informational: informational.length,
    total: matches.length,
  };
};
